module.exports = __webpack_public_path__ + "static/media/default-pn.ec2857d9.png";